export default {
  dragOrClick: 'Drag a file here or click to upload - up to {maxSize} | Drag files here or click to upload - up to {maxSize} per file',
  uploadError: 'The file was not uploaded due to an invalid format or file size: | Some files were not uploaded due to an invalid format or file size:',
  dragError: {
    onDragTooManyFiles: 'Only one file can be uploaded at a time.',
    onDragSomeUnsupportedMimetype: 'Some of the selected files have unsupported formats.',
    onDragAllUnsupportedMimetype: 'None of the file formats are supported.',
    onDragUnsupportedMimetype: 'The file format is not supported.',
  },
};
